import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { I18n } from "@/i18n/I18n";
import { FileSubjectTypes } from "@/types/fileTypes";
import { File } from "@/backend/models/file";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { DeleteButton } from "../buttons/DeleteButton";
import { UpdatedParamsAndRefs } from "@/frontend/store/TreeStore";
import { FileWithDisplay } from "./FileWithDisplay";
import { DownloadFileButton } from "./DownloadFileButton";
import { FileUploadWrapper } from "./FileUploadWrapper";

export function FileUploader(props: {
  isInput?: boolean,
  subjectId: string,
  subjectType: FileSubjectTypes,
  readOnly?: boolean;
  inputConstraint?: string,
  file?: File,
  allowCapture?: boolean,
  refetchSubject: (updatedConsumers: UpdatedParamsAndRefs) => void,
  hideFilePreview?: boolean,
}) {
  const { subjectId, subjectType, readOnly, inputConstraint, file, refetchSubject, isInput = true, hideFilePreview = false } = props;
  const createFile = useGlobalStore(state => state.createFile);
  const deleteFile = useGlobalStore(state => state.deleteFile);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  async function handleCreateFile(event: React.ChangeEvent<HTMLInputElement>) {
    const newFile = event.target.files?.[0];
    if (!newFile) return;
    setUploading(true);
    try {
      await createFile({ fileName: newFile.name, subjectId, subjectType }, newFile, refetchSubject, setUploadProgress);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  }

  if (!file) {
    if (readOnly && !isInput) {
      return <div>{I18n.get('noFileUploaded')}</div>;
    }

    return (
      <FileUploadWrapper uploading={uploading} uploadProgress={uploadProgress}>
        <div className="d-flex gap-2 align-items-center">
          <Form.Control type="file" onChange={(event: React.ChangeEvent<HTMLInputElement>) => void handleCreateFile(event)} accept={inputConstraint} aria-label={I18n.get('selectFile')} disabled={readOnly} />
        </div>
      </FileUploadWrapper>
    );
  }

  return (
    <div className='w-100'>
      <FileWithDisplay file={file} hideFilePreview={hideFilePreview} />
      <div>
        <div>{file.fileName}</div>
        <div className="ms-auto d-flex gap-1">
          <DownloadFileButton file={file} />
          {!readOnly && <DeleteButton onDelete={() => deleteFile(file.id, refetchSubject)} model={I18n.get('file')} title={file.fileName} /> }
        </div>
      </div>
    </div>
  );
}
